import { render } from "./ModalToDo.vue?vue&type=template&id=818f29a6"
import script from "./ModalToDo.vue?vue&type=script&lang=js"
export * from "./ModalToDo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__